import { ACTION_STATES } from "core/actions";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Select from "../common/Select";
import actions from "./logic/actions";

class ContactSelectDropdown extends React.Component {
    static defaultProps = {
        placeholder: "All Contacts",
    };
    constructor(props) {
        super(props);
        this.state = {
            value: props.defaultValue ? props.defaultValue : null,
            companyContacts: props.company ? props.company.contacts : null,
        };
        this.onChange = this.onChange.bind(this);
        this.onInput = this.onInput.bind(this);
    }
    onChange(value) {
        this.setState({ value }, () => {
            this.props.onChange(this.state.value);
        });
    }

    onSearchByCompanyContact = (value) => {
        if (value !== "") {
            this.setState({
                companyContacts: this.props.company.contacts.filter(
                    (contact) =>
                        `${contact.firstName} ${contact.lastName}`.toLowerCase().indexOf(value.toLowerCase()) !== -1
                ),
            });
        } else this.setState({ companyContacts: this.props.company.contacts });
    };

    onInput(e, a) {
        if (a && a.action.match(/input-blur|menu-close/)) return;
        this.setState({
            loading: false,
        });
        if (this.props.company) {
            this.onSearchByCompanyContact(e.target.value);
        } else {
            if (e.target.value.length > 2) {
                this.props.onLoadContacts(e.target.value);
            } else {
                if (e.target.value !== "")
                    this.setState({
                        loading: true,
                    });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
        if (prevProps.company !== this.props.company) {
            this.setState({ companyContacts: this.props.company ? this.props.company.contacts : null });
        }
    }

    render() {
        const { value, companyContacts } = this.state;
        const { contacts, contactsStatus, placeholder, company } = this.props;
        const isLoading = contactsStatus === ACTION_STATES.SEND;
        contacts.map((c) => Object.assign(c, { name: `${c.firstName} ${c.lastName}` }));
        const data =
            company && companyContacts
                ? companyContacts.map((contact) => ({
                    value: contact.id,
                    name: `${contact.firstName} ${contact.lastName}`,
                    label: `${contact.firstName} ${contact.lastName}`,
                    ...contact,
                }))
                : contacts.map((contact) => ({ value: contact.id, label: contact.name, ...contact }));
        return (
            <Select
                onInput={(e, a) => this.onInput({ target: { value: e } }, a)}
                onChange={this.onChange}
                options={data}
                value={value}
                defaultMenuPortalTarget
                loading={isLoading}
                placeholder={placeholder}
            />
        );
    }
}

ContactSelectDropdown.propTypes = {
    onChange: PropTypes.func,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    company: PropTypes.object,
    contacts: PropTypes.array,
    contactsStatus: PropTypes.string,
    onLoadContacts: PropTypes.func,
};

export default connect(
    ({ globalApp }) => ({
        contacts: globalApp.contacts,
        contactsStatus: globalApp.loadContacts,
    }),
    (dispatch) => ({
        onLoadContacts: (str) => dispatch(actions.GET_CONTACTS.send(str)),
    })
)(ContactSelectDropdown);
